import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";


const AdvanceStaff = () => {
  const { staffId } = useParams();
  const [staffDetails, setStaffDetails] = useState(null);
  const [advanceAmount, setAdvanceAmount] = useState("");
  const [reason, setReason] = useState("");
  const [advances, setAdvances] = useState([]);
  const [ledger, setLedger] = useState(null); // State to store ledger details
  const [paymentMode, setPaymentMode] = useState(""); // State to track payment mode
  const [session, setSession] = useState(""); // Store session ID from localStorage
const [sessionName, setSessionName] = useState("");
const location = useLocation();

const staffType = new URLSearchParams(location.search).get("type");

  // Fetch staff details and ledger details
  const fetchStaffAndLedgerDetails = async () => {
    try {
      if (!session) {
        alert("No session ID found.");
        return;
      }

      // Fetch staff details with sessionId in params
const staffResponse = await axios.get(
  staffType === "teacher"
    ? ` ${process.env.REACT_APP_API_BASE_URL}/api/teachers/getTeacherById/${staffId}`
    : ` ${process.env.REACT_APP_API_BASE_URL}/api/nonTeachingStaff/getNonTeachingStaffById/${staffId}`,
  { params: { sessionId: session } }
);

setStaffDetails(staffResponse.data);
console.log("Staff details:", staffResponse.data);


      // Fetch ledger details
      const ledgerResponse = await axios.get(
        ` ${process.env.REACT_APP_API_BASE_URL}/api/ledgers/getLedgerByStaffId/${staffId}`
      );
      setLedger(ledgerResponse.data);
const ledgerSession = ledgerResponse.data.sessionId;

if (ledgerSession && typeof ledgerSession === "object") {
  setSessionName(ledgerSession.sessionName);
} else {
  setSessionName("Current Session");
}

      console.log("Ledger details:", ledgerResponse.data);
    } catch (error) {
      console.error("Error fetching details:", error.response ? error.response.data : error.message);
      alert(`Error fetching details: ${error.response ? error.response.data.message : error.message}`);
    }
  };

  useEffect(() => {
    const storedSession = localStorage.getItem("currentSessionId");

    if (!storedSession) {
      alert("No session found in local storage. Please log in again.");
      window.location.href = "/login";  
    } else {
      console.log("Session ID from localStorage: ", storedSession);
      setSession(storedSession); // Set the session ID from local storage
    }
  }, []);

  useEffect(() => {
    // Only call fetchStaffAndLedgerDetails once session is set
    if (staffId && session) {
      fetchStaffAndLedgerDetails();
    }
  }, [staffId, session]); // Dependency on both staffId and session

  // Handle advance submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!advanceAmount || !reason || !paymentMode || !ledger || !session) {
      alert("Please fill out all fields.");
      return;
    }

    const amount = parseFloat(advanceAmount);
    if (amount > ledger.balance) {
      alert("Advance amount exceeds available balance.");
      return;
    }

    const newAdvance = {
      sessionId: session, // Use the session ID directly from state (which is from localStorage)
      amount,
      reason,
      date: new Date().toLocaleDateString(),
    };

    setAdvances([...advances, newAdvance]); // Add new advance to the list

    // Create advance entry in the backend
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/ledgers/staff/advance`,
        {
          staffId,
          ledgerId: ledger._id, // Using the correct ledger ID
          date: new Date(),
          description: `ADVANCE: ${reason}`,
          advanceAmount: amount,
          sessionId: session, // Using the session from state
          receiptNumber: `RCPT-${Date.now()}`, // Example receipt number
        }
      );
      console.log("Advance entry created:", response.data);

      // Update the current balance after successful submission
      setLedger((prev) => ({ ...prev, balance: prev.balance - amount }));
    } catch (error) {
      console.error("Error creating advance entry:", error);
      alert("Failed to create advance entry. Please try again.");
    }

    // Reset input fields
    setAdvanceAmount("");
    setReason("");
    setPaymentMode("");
  };

  // Loading state
  if (!staffDetails || !ledger) {
    return <div>Loading staff details...</div>;
  }

  return (
    <div className="p-8 bg-white border border-gray-300 rounded-lg shadow-md">
      <h3 className="text-lg mb-2">
        <strong>Staff Details:</strong>
      </h3>
      <p>
        <strong>ID:</strong> {staffDetails._id}
      </p>
      <p>
        <strong>Name:</strong> {staffDetails.firstName} {staffDetails.lastName}
      </p>
      <p>
        <strong>Current Balance (INR):</strong>{" "}
        {ledger.balance.toLocaleString("en-IN")}
      </p>

      <form onSubmit={handleSubmit} className="mt-6 mb-6">
        <div className="flex flex-col">
          <label className="text-gray-700 font-semibold my-2">Session:</label>
          {/* Session is now from localStorage, no need for dropdown */}
          <input
            type="text"
            value={sessionName || "No session available"}
            readOnly
            className="border rounded-lg px-3 my-2 outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </div>

        <div className="mb-4">
          <label className="block mb-2 font-semibold">
            Advance Amount (INR):
          </label>
          <input
            type="number"
            value={advanceAmount}
            onChange={(e) => setAdvanceAmount(e.target.value)}
            className="p-3 border border-gray-300 rounded w-full"
            placeholder="Enter advance amount"
            required
          />
        </div>

        <div className="mb-4">
          <label className="block mb-2 font-semibold">
            Reason for Advance:
          </label>
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            className="p-3 border border-gray-300 rounded w-full"
            placeholder="Enter reason for advance"
            required
          />
        </div>

        <div className="mb-4">
          <label className="block mb-2 font-semibold">Payment Mode:</label>
          <select
            value={paymentMode}
            onChange={(e) => setPaymentMode(e.target.value)}
            className="p-3 border border-gray-300 rounded w-full"
            required
          >
            <option value="">Select Payment Mode</option>
            <option value="Cash">Cash</option>
            <option value="Cheque">Cheque</option>
            <option value="Online">Online</option>
          </select>
        </div>

        <button
          type="submit"
          className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 transition"
        >
          Submit Advance
        </button>
      </form>
    </div>
  );
};

export default AdvanceStaff;
